import React from 'react';
import { useQuery } from '@apollo/client';
import Hero from '../../common/Hero';
import ImageSlider from '../../common/Image-slider';
import styled, { keyframes } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHatWizard } from '@fortawesome/free-solid-svg-icons';
import WhatsOn from '../../common/What-on';
import MouseJourneyBanner from '../../common/MouseJourneyBanner';
import NewsletterSignUp from '../../common/Newsletter-sign';
import ColumnX2 from '../../common/Column-x2';
import ImageSlant from '../../common/image-slant';
import Footer from '../../Footer/Footer';
import { processEvents, GET_EVENTS_QUERY, combineAndSortEvents, filterPastHardcodedEvents } from '../../../utils/eventUtils';
import { getCastleOpeningDisplay, getGardensOpeningDisplay, isHalloweenAndEarlyBirdRetired } from '../../../utils/openingHoursUtils';
import { gql } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import SEO from '../../common/SEO';
import { Helmet } from 'react-helmet-async';
import { getCanonicalUrl } from '../../../utils/seo';
import ToursSlider from '../../common/ToursSlider';
import playgroundVideo from '../../../assets/BelvoirCastlePlayground.mp4';
import BringYourDogLabel from '../../common/BringYourDogLabel';
const gardensImage = 'https://BelvoirCastle.b-cdn.net/images/gardens.webp';

const vineyardImage = 'https://BelvoirCastle.b-cdn.net/Vineyard/vineyard.webp';

const farmshopImage = 'https://BelvoirCastle.b-cdn.net/Retail%20village/Farmshop/farmshop.webp';
const retailImage = 'https://BelvoirCastle.b-cdn.net/Retail%20village/retail1.webp';
const retailVillageImage = 'https://BelvoirCastle.b-cdn.net/Retail%20village/retail3.webp';

const imgGrotto = 'https://BelvoirCastle.b-cdn.net/Christmas/grotto.webp';
const imgFestive = 'https://BelvoirCastle.b-cdn.net/Christmas/festive.webp';
const imgFestiveTea = 'https://BelvoirCastle.b-cdn.net/Afternoon%20Tea/Festive/WhatsApp%20Image%202026-10-20%20at%2010.13.47.jpeg';
const imgCandlelight =
  'https://BelvoirCastle.b-cdn.net/Christmas/candle%20light/Belvoir%20Castle%20Christmas-59.webp';

const castleImage = 'https://BelvoirCastle.b-cdn.net/Castle/castle.webp';

const bannerHome1 = 'https://BelvoirCastle.b-cdn.net/Banners/home%20page%20banner/1.webp';

const farmImage = 'https://BelvoirCastle.b-cdn.net/Animal%20park/farm.webp';

const playgroundImage = 'https://BelvoirCastle.b-cdn.net/Adventure%20park/play.webp';

const halloweenHeroImage =
  'https://BelvoirCastlePull.b-cdn.net/Website/girl-curse.webp';
const halloweenCraftsImage =
  'https://BelvoirCastle.b-cdn.net/Halloween/crafts.webp';

const imgSearch =
  'https://BelvoirCastle.b-cdn.net/Christmas/Designer.webp';
const imgMouseJourney =
  'https://BelvoirCastle.b-cdn.net/Christmas/MouseTrail/Mouse1.png';

const discoverCastleImage =
  'https://BelvoirCastlePull.b-cdn.net/Website/CJP%20Belvoir%20Castle-234%20(1).webp';

const beautifulGardensImage =
  'https://BelvoirCastlePull.b-cdn.net/Website/CJP%20Belvoir%20Castle-269%20(1).webp';

const featuredToursImage =
  'https://BelvoirCastlePull.b-cdn.net/Website/TheCrown_301_Unit_00345_RC.webp';

const vineyardToursImage =
  'https://BelvoirCastlePull.b-cdn.net/Website/Vineyard%203%20(1).webp';

const C = {
  navy: '#101d40',
  bronze: '#9d6d49',
  bronzeDk: '#8a5d39',
  gold: '#C9963C', // Christmas section only
  goldDk: '#A67C2A', // Christmas section only
  ivory: '#FAF7F0',
  parchment: '#F3EDD8',
};

// Helper function to get the 3rd Sunday of a given month
const getThirdSunday = (year, month) => {
  const firstDay = new Date(year, month, 1);
  const firstSunday = firstDay.getDay() === 0 ? 1 : (7 - firstDay.getDay() + 1);
  const thirdSunday = firstSunday + 14;
  return new Date(year, month, thirdSunday);
};

// Generate Antiques Market event (single event covering all dates)
const generateAntiquesMarketEvents = () => {
  const year = 2026;
  // Get first date (April) and last date (September)
  const firstDate = getThirdSunday(year, 3); // April
  const lastDate = getThirdSunday(year, 8); // September
  
  return [{
    id: 'antiques-artisan-market-2026',
    title: 'Vintage & Craft Market',
    subtitle: '3rd Sunday Every Month | April - September',
    date: '3rd Sunday Every Month | April - September',
    description: 'A monthly celebration of craftsmanship, character and timeless finds. Browse curated stalls featuring local artists, makers, antiques and collectables. Free entry.',
    image: retailVillageImage,
    location: 'RETAIL VILLAGE',
    link: '/events/antiques-artisan-market',
    linkText: 'Discover the Market',
    eventTags: ['market', 'family', 'free'],
    eventDetails: {
      eventDate: firstDate.toISOString().split('T')[0],
      eventEndDate: lastDate.toISOString().split('T')[0],
      eventTime: '10:00 - 16:00',
      eventTags: ['market', 'family', 'outdoor', 'food'],
    }
  }];
};

const HomeContainer = styled.div`
  min-height: 100vh;
  padding-top: 158px;
  background: ${C.ivory};
`;

const ExploreIntro = styled.div`
  max-width: 42rem;
  margin: 0 auto clamp(1.5rem, 4vw, 2.35rem);
  padding: 0 clamp(1rem, 4vw, 2rem);
  text-align: center;
`;

const ExploreEyebrow = styled.p`
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: ${C.bronze};
  margin: 0 0 0.65rem;
`;

const ExploreDivider = styled.div`
  width: 48px;
  height: 2px;
  background: ${C.bronze};
  margin: 0 auto 1rem;
  border-radius: 2px;
`;

const ExploreTitle = styled.h2`
  font-family: ${props => props.theme.fonts.main};
  font-size: clamp(1.85rem, 4.2vw, 2.45rem);
  font-weight: 700;
  color: ${props => props.theme.colors.primary};
  margin: 0;
  line-height: 1.12;

  em {
    font-style: italic;
    color: ${C.bronze};
  }
`;

const ExploreSubtitle = styled.p`
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: clamp(0.9rem, 1.85vw, 1rem);
  color: rgba(16, 29, 64, 0.58);
  margin: 0.85rem 0 0;
  line-height: 1.55;
  max-width: 34rem;
  margin-left: auto;
  margin-right: auto;
`;

// ── HALLOWEEN HANDOFF ────────────────────────────────────────────────────────

const homeWitchFade = keyframes`
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const HomeWitchPanel = styled.section`
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #0d0a14 0%, #1a0a22 60%, #0a0d10 100%);
  padding: clamp(3rem, 8vw, 5.5rem) clamp(1.25rem, 5vw, 3.5rem);
  text-align: center;
`;

const HomeWitchBg = styled.div`
  position: absolute;
  inset: 0;
  background-image: url('https://BelvoirCastlePull.b-cdn.net/Website/5S5A1084-2%20(1).webp');
  background-size: cover;
  background-position: center 30%;
  opacity: 0.12;
`;

const HomeWitchInner = styled.div`
  position: relative;
  z-index: 1;
  max-width: 640px;
  margin: 0 auto;
  animation: ${homeWitchFade} 0.7s ease both;
`;

const HomeWitchIcon = styled.div`
  margin: 0 auto 1rem;
  font-size: clamp(1.75rem, 4vw, 2.25rem);
  color: rgba(200, 160, 255, 0.75);
  line-height: 1;
`;

const HomeWitchHeadline = styled.h2`
  font-family: 'Playfair Display', Georgia, serif;
  font-size: clamp(1.4rem, 3.5vw, 2rem);
  font-weight: 700;
  color: #e8d5ff;
  margin: 0 0 0.75rem;
  line-height: 1.25;
`;

const HomeWitchBody = styled.p`
  font-size: clamp(0.88rem, 1.6vw, 1rem);
  color: rgba(232, 213, 255, 0.7);
  margin: 0 0 1.75rem;
  line-height: 1.65;
`;

const HomeWitchBtn = styled.button`
  display: inline-block;
  padding: 0.85rem 2.25rem;
  border-radius: 999px;
  background: linear-gradient(135deg, #4a1060 0%, #7b2fa0 100%);
  color: #e8d5ff;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.13em;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
  box-shadow: 0 6px 22px rgba(100, 30, 140, 0.4);
  transition: filter 0.2s ease, transform 0.2s ease;

  &:hover {
    filter: brightness(1.1);
    transform: translateY(-1px);
  }
`;

// ── CHRISTMAS (gold accents — Christmas section only) ─────────────────────────

const ChristmasSection = styled.section`
  position: relative;
  padding: clamp(2.75rem, 6vw, 4.25rem) clamp(1.25rem, 4vw, 2rem);
  background: #080f20;
  overflow: hidden;
  scroll-margin-top: 160px;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background:
      radial-gradient(ellipse at 15% 60%, rgba(201, 150, 60, 0.14) 0%, transparent 55%),
      radial-gradient(ellipse at 85% 10%, rgba(16, 29, 64, 0.6) 0%, transparent 50%);
    pointer-events: none;
  }
`;

const ChristmasInner = styled.div`
  position: relative;
  z-index: 1;
  max-width: 1100px;
  margin: 0 auto;
`;

const ChristmasHeader = styled.div`
  text-align: center;
  max-width: 42rem;
  margin: 0 auto clamp(2rem, 4vw, 2.75rem);
`;

const ChristmasEyebrow = styled.p`
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: ${C.gold};
  margin: 0 0 0.65rem;
`;

const ChristmasDivider = styled.div`
  width: 48px;
  height: 2px;
  background: ${C.gold};
  margin: 0 auto 1rem;
  border-radius: 2px;
`;

const ChristmasTitle = styled.h2`
  font-family: ${props => props.theme.fonts.main};
  font-size: clamp(1.85rem, 4.2vw, 2.45rem);
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  line-height: 1.12;

  em {
    font-style: italic;
    color: ${C.gold};
  }
`;

const ChristmasLead = styled.p`
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: clamp(0.95rem, 1.85vw, 1.05rem);
  line-height: 1.65;
  color: rgba(255, 255, 255, 0.62);
  margin: 0.85rem auto 0;
  max-width: 36rem;
`;

const ChristmasGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: clamp(1rem, 2.5vw, 1.35rem);
  margin-bottom: clamp(1.75rem, 3vw, 2.25rem);

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const ChristmasCard = styled.button`
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 0;
  border: 1px solid rgba(201, 150, 60, 0.22);
  border-radius: 14px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.04);
  cursor: pointer;
  transition: border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    border-color: rgba(201, 150, 60, 0.55);
    transform: translateY(-2px);
    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.25);
  }
`;

const ChristmasCardImage = styled.img`
  display: block;
  width: 100%;
  height: 180px;
  object-fit: cover;
`;

const ChristmasCardBody = styled.div`
  padding: 1.15rem 1.25rem 1.3rem;
  border-top: 2px solid rgba(201, 150, 60, 0.35);
`;

const ChristmasCardTitle = styled.h3`
  font-family: ${props => props.theme.fonts.main};
  font-size: 1.05rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 0.45rem;
  line-height: 1.25;
`;

const ChristmasCardText = styled.p`
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 0.875rem;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.62);
  margin: 0 0 0.85rem;
`;

const ChristmasCardLink = styled.span`
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${C.gold};
`;

const ChristmasCtaRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.75rem;
`;

const ChristmasPrimaryBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.9rem 2rem;
  border-radius: 999px;
  border: none;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #ffffff;
  background: ${C.gold};
  cursor: pointer;
  transition: background 0.2s ease, transform 0.18s ease;

  &:hover {
    background: ${C.goldDk};
    transform: translateY(-1px);
  }
`;

const ChristmasSecondaryBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.9rem 1.85rem;
  border-radius: 999px;
  border: 1.5px solid rgba(255, 255, 255, 0.35);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #ffffff;
  background: transparent;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease;

  &:hover {
    border-color: rgba(255, 255, 255, 0.6);
    background: rgba(255, 255, 255, 0.06);
  }
`;

// ── CHILDREN'S SUMMER RETURN OFFER (navy banner) ─────────────────────────────

const ChildrenReturnBanner = styled.section`
  background: linear-gradient(135deg, #101d40 0%, #1a3352 100%);
  padding: clamp(2rem, 5vw, 2.75rem) clamp(1.25rem, 4vw, 2rem);
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
`;

const ChildrenReturnInner = styled.div`
  max-width: 860px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.75rem 2.5rem;
  flex-wrap: wrap;

  @media (max-width: 640px) {
    flex-direction: column;
    text-align: center;
    align-items: center;
  }
`;

const ChildrenReturnAccent = styled.div`
  width: 3px;
  align-self: stretch;
  background: linear-gradient(180deg, ${C.bronze} 0%, rgba(157, 109, 73, 0.3) 100%);
  border-radius: 3px;
  flex-shrink: 0;

  @media (max-width: 640px) {
    width: 48px;
    height: 3px;
    align-self: auto;
  }
`;

const ChildrenReturnCopy = styled.div`
  flex: 1;
  min-width: 0;
`;

const ChildrenReturnEyebrow = styled.p`
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: ${C.bronze};
  margin: 0 0 0.5rem;
`;

const ChildrenReturnHeadline = styled.h2`
  font-family: ${props => props.theme.fonts.main};
  font-size: clamp(1.2rem, 2.8vw, 1.6rem);
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 0.55rem;
  line-height: 1.2;
`;

const ChildrenReturnSubtext = styled.p`
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: clamp(0.875rem, 1.7vw, 0.95rem);
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
`;

const ChildrenReturnCTA = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0.85rem 1.65rem;
  border-radius: 999px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #101d40;
  background: #ffffff;
  border: 2px solid #ffffff;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;

  &:hover {
    background: ${C.bronze};
    border-color: ${C.bronze};
    color: #ffffff;
  }
`;

// ── JUNE TICKET PICKER (modal overlay) ──────────────────────────────────────

const JunePickerOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(16, 29, 64, 0.55);
  backdrop-filter: blur(4px);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  animation: fadeIn 0.2s ease;

  @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
`;

const JunePickerModal = styled.div`
  background: #fff;
  border-radius: 20px;
  padding: clamp(1.75rem, 4vw, 2.5rem);
  max-width: 560px;
  width: 100%;
  box-shadow: 0 24px 80px rgba(16, 29, 64, 0.22);
  position: relative;
`;

const JunePickerClose = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  cursor: pointer;
  color: rgba(16, 29, 64, 0.4);
  font-size: 1.4rem;
  line-height: 1;
  padding: 0.25rem;
  &:hover { color: #101d40; }
`;

const JunePickerEyebrow = styled.p`
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: ${C.bronze};
  margin: 0 0 0.4rem;
  text-align: center;
`;

const JunePickerTitle = styled.h2`
  font-family: ${props => props.theme.fonts.main};
  font-size: clamp(1.1rem, 2.5vw, 1.4rem);
  font-weight: 700;
  color: #101d40;
  margin: 0 0 0.35rem;
  text-align: center;
  line-height: 1.2;
`;

const JunePickerSub = styled.p`
  font-size: 0.88rem;
  color: rgba(16, 29, 64, 0.55);
  text-align: center;
  margin: 0 0 1.5rem;
  line-height: 1.5;
`;

const JunePickerGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;

  @media (max-width: 420px) {
    grid-template-columns: 1fr;
  }
`;

const JunePickerCard = styled.a`
  display: flex;
  flex-direction: column;
  padding: 1.35rem 1.25rem;
  border-radius: 14px;
  border: 2px solid rgba(16, 29, 64, 0.1);
  text-decoration: none;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
  background: #fff;

  &:hover {
    border-color: ${C.bronze};
    box-shadow: 0 6px 24px rgba(16, 29, 64, 0.1);
    transform: translateY(-2px);
  }
`;

const JunePickerCardTitle = styled.span`
  font-family: ${props => props.theme.fonts.main};
  font-size: 1rem;
  font-weight: 700;
  color: #101d40;
  margin-bottom: 0.3rem;
  display: block;
`;

const JunePickerCardDesc = styled.span`
  font-size: 0.8rem;
  color: rgba(16, 29, 64, 0.55);
  line-height: 1.45;
  display: block;
  margin-bottom: 0.9rem;
`;

const JunePickerCardCTA = styled.span`
  margin-top: auto;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${C.bronze};
`;

// ── END CHILDREN'S RETURN BANNER STYLES ─────────────────────────────────────

const FreeClubsSection = styled.section`
  margin: 0;
  padding: clamp(2.75rem, 6vw, 4.25rem) clamp(1.25rem, 4vw, 2rem);
  border-top: 1px solid rgba(16, 29, 64, 0.07);
  background: linear-gradient(
    180deg,
    ${C.ivory} 0%,
    rgba(243, 237, 216, 0.45) 42%,
    ${C.ivory} 100%
  );
`;

const FreeClubsContainer = styled.div`
  max-width: 1080px;
  margin: 0 auto;
  text-align: center;
`;

const FreeClubsBadge = styled.span`
  display: inline-block;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: ${C.bronze};
  background: rgba(157, 109, 73, 0.08);
  border: 1px solid rgba(157, 109, 73, 0.25);
  padding: 0.45rem 1rem;
  border-radius: 999px;
  margin-bottom: 1rem;
`;

const FreeClubsTitle = styled.h2`
  font-family: ${props => props.theme.fonts.main};
  font-size: clamp(1.85rem, 4vw, 2.45rem);
  font-weight: 700;
  color: ${props => props.theme.colors.primary};
  margin: 0 0 1rem;
  line-height: 1.12;

  &::after {
    content: '';
    display: block;
    width: 3rem;
    height: 2px;
    margin: 1.15rem auto 0;
    border-radius: 2px;
    background: linear-gradient(
      90deg,
      transparent,
      ${C.bronze},
      transparent
    );
    opacity: 0.85;
  }
`;

const FreeClubsDescription = styled.p`
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: clamp(0.95rem, 1.9vw, 1.08rem);
  line-height: 1.65;
  color: rgba(16, 29, 64, 0.62);
  margin: 0 auto 2.25rem;
  max-width: 38rem;
`;

const FreeClubsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: clamp(1rem, 3vw, 1.5rem);
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FreeClubCard = styled.div`
  text-align: left;
  padding: 1.35rem 1.4rem 1.45rem;
  border-radius: 16px;
  border: 1px solid rgba(16, 29, 64, 0.08);
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  box-shadow:
    0 8px 32px rgba(16, 29, 64, 0.07),
    0 1px 0 rgba(255, 255, 255, 0.85) inset;
  transition:
    box-shadow 0.25s ease,
    border-color 0.25s ease,
    transform 0.25s ease;

  &:hover {
    border-color: rgba(157, 109, 73, 0.28);
    box-shadow:
      0 12px 40px rgba(16, 29, 64, 0.1),
      0 1px 0 rgba(255, 255, 255, 0.9) inset;
    transform: translateY(-2px);
  }
`;

const FreeClubName = styled.h3`
  font-family: ${props => props.theme.fonts.main};
  font-size: clamp(1.1rem, 2.2vw, 1.28rem);
  font-weight: 700;
  color: ${props => props.theme.colors.primary};
  margin: 0 0 1.1rem;
  line-height: 1.25;
`;

const FreeClubBookBtn = styled.button`
  width: 100%;
  background: ${C.bronze};
  color: white;
  border: none;
  padding: 0.65rem 1.1rem;
  border-radius: 999px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(157, 109, 73, 0.35);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;

  &:hover {
    background: ${C.bronzeDk};
    transform: translateY(-1px);
    box-shadow: 0 6px 18px rgba(157, 109, 73, 0.42);
  }
`;

const FreeClubsPageLink = styled.button`
  background: rgba(255, 255, 255, 0.5);
  color: ${props => props.theme.colors.primary};
  border: 1px solid rgba(16, 29, 64, 0.14);
  padding: 0.75rem 1.6rem;
  border-radius: 999px;
  font-family: ${props => props.theme.fonts.main};
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  transition:
    border-color 0.2s ease,
    color 0.2s ease,
    background 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    border-color: ${C.bronze};
    color: ${C.bronze};
    background: rgba(255, 255, 255, 0.85);
    box-shadow: 0 4px 16px rgba(16, 29, 64, 0.06);
  }
`;

const GET_SITE_SETTINGS = gql`
  query GetSiteSettings {
    siteSettings(where: {title: "Global Site Settings"}) {
      nodes {
        title
        siteSettingsFields {
          openingHours {
            castle {
              days
              times
              note
            }
            gardens {
              days
              times
              note
            }
            retail {
              days
              times
              note
            }
          }
          homeHero {
            welcomeText
            mainTitle
            subtitle
            heroVideo {
              node {
                sourceUrl
              }
            }
            sliderContent {
              slide1 {
                image {
                  node {
                    sourceUrl
                  }
                }
                title
                url
              }
              slide2 {
                image {
                  node {
                    sourceUrl
                  }
                }
                title
                url
              }
              slide3 {
                image {
                  node {
                    sourceUrl
                  }
                }
                title
                url
              }
              slide4 {
                image {
                  node {
                    sourceUrl
                  }
                }
                title
                url
              }
            }
          }
          familySection {
            title
            description
          }
        }
      }
    }
  }
`;

const GET_OPENING_HOURS = gql`
  query GetOpeningHours {
    siteSettings {
      nodes {
        siteSettingsFields {
          openingHours {
            castle {
              days
              times
              note
            }
            gardens {
              days
              times
              note
            }
            retail {
              days
              times
              note
            }
          }
        }
      }
    }
  }
`;

const Home = () => {
  const navigate = useNavigate();

  const { loading: settingsLoading, error: settingsError, data: settingsData } = useQuery(GET_SITE_SETTINGS, {
    fetchPolicy: 'network-only'
  });


  if (settingsError) {


  }

  const settings = settingsData?.siteSettings?.nodes?.[0]?.siteSettingsFields || {};

  const { data: hoursData } = useQuery(GET_OPENING_HOURS);

  const openingHoursData = hoursData?.siteSettings?.nodes?.[0]?.siteSettingsFields?.openingHours || {};
  const castleOpeningDisplay = getCastleOpeningDisplay(openingHoursData.castle);
  const gardensOpeningDisplay = getGardensOpeningDisplay(openingHoursData.gardens);

  const { loading: eventsLoading, error: eventsError, data: eventsData } = useQuery(GET_EVENTS_QUERY);

  const defaultSliderContent = [
    {
      image: castleImage,
      title: "Castle and State Rooms",
      action: () => navigate('/about/castle-and-state-rooms')
    },
    {
      image: gardensImage,
      title: "Formal Gardens and Woodland",
      action: () => navigate('/about/gardens')
    },
    {
      image: retailImage,
      title: "Belvoir Castle Retail Village",
      action: () => navigate('/retail-village')
    },
    {
      image: playgroundImage,
      title: "Adventure Playground",
      action: () => navigate('/about/adventure-playground')
    },
    {
      image: farmImage,
      title: "Animal Park",
      action: () => navigate('/retail-village/animal-park')
    },
    {
      image: vineyardImage,
      title: "Vineyard Tours",
      action: () => navigate('/whats-on/vineyard-tour')
    }
  ];

  const sliderContent = settings.homeHero?.sliderContent
    ? [
        settings.homeHero.sliderContent.slide1 && {
          image: settings.homeHero.sliderContent.slide1.image?.node?.sourceUrl || castleImage,
          title: settings.homeHero.sliderContent.slide1.title || "Castle and State Rooms",
          action: () => navigate(settings.homeHero.sliderContent.slide1.url || '/about/castle-and-state-rooms')
        },
        settings.homeHero.sliderContent.slide2 && {
          image: settings.homeHero.sliderContent.slide2.image?.node?.sourceUrl || gardensImage,
          title: settings.homeHero.sliderContent.slide2.title || "Formal Gardens and Woodland",
          action: () => navigate(settings.homeHero.sliderContent.slide2.url || '/about/gardens')
        },
        settings.homeHero.sliderContent.slide3 && {
          image: settings.homeHero.sliderContent.slide3.image?.node?.sourceUrl || retailImage,
          title: settings.homeHero.sliderContent.slide3.title || "Retail Village",
          action: () => navigate(settings.homeHero.sliderContent.slide3.url || '/retail-village')
        },
        settings.homeHero.sliderContent.slide4 && {
          image: settings.homeHero.sliderContent.slide4.image?.node?.sourceUrl || playgroundImage,
          title: settings.homeHero.sliderContent.slide4.title || "Adventure Playground",
          action: () => navigate(settings.homeHero.sliderContent.slide4.url || '/about/adventure-playground')
        }
      ].filter(Boolean)
    : defaultSliderContent;

  // Generate Antiques Market events
  const antiquesMarketEvents = generateAntiquesMarketEvents();
  
  const halloweenEvents = [
    {
      id: 'belvoir-wicked-night-2026',
      title: "Belvoir's Enchanted Halloween Trail",
      subtitle: 'October School Holidays 2026',
      date: 'October School Holidays 2026',
      description: 'A pesky witch has cursed Belvoir. Collect spell ingredients, find the password animal in the Animal Park, and brew the counter-curse at the cauldron. A family Halloween adventure trail — silly, not scary. Animal Park included with every ticket.',
      image: halloweenHeroImage,
      location: 'Estate',
      link: '/halloween-belvoir-castle',
      linkText: 'Discover Enchanted Halloween Trail',
      ticketTier: 'Book online',
      eventTags: ['family', 'trail', 'halloween'],
      eventDetails: {
        eventDate: '2026-10-03',
        eventEndDate: '2026-11-01',
      }
    },
    {
      id: 'belvoir-halloween-crafts-2026',
      title: 'Halloween Crafts',
      subtitle: 'October School Holidays 2026 · £4.50 per child',
      date: 'October School Holidays 2026',
      description: 'Hands-on Halloween crafts in the Retail Village. £4.50 per child. Book standalone or add to your Enchanted Halloween Trail visit. Take the magic home.',
      image: halloweenCraftsImage,
      location: 'Retail Village',
      link: '/halloween-crafts',
      linkText: 'Discover Halloween Crafts',
      ticketTier: '£4.50 per child',
      eventTags: ['family', 'crafts', 'halloween'],
      eventDetails: {
        eventDate: '2026-10-03',
        eventEndDate: '2026-11-01',
      }
    }
  ];

  const christmasWhatsOnEvents = [
    {
      id: 'belvoir-christmas-2026',
      title: 'Christmas at Belvoir Castle',
      subtitle: '14 November – 30 December 2026',
      date: '14 November – 30 December 2026',
      description: 'Deck the Halls carol rooms, the Mice Trail, Santa, festive afternoon tea, and Castle by Candlelight. A Christmas visit for every generation.',
      image: imgFestive,
      location: 'Castle',
      link: '/christmas',
      linkText: 'Discover Christmas',
      ticketTier: 'Book online',
      eventTags: ['christmas', 'family', 'castle'],
      eventDetails: {
        eventDate: '2026-11-14',
        eventEndDate: '2026-12-30',
      }
    },
    {
      id: 'belvoir-castle-by-candlelight-2026',
      title: 'Castle by Candlelight',
      subtitle: 'Selected dates throughout December 2026',
      date: 'Selected dates throughout December 2026',
      description: 'An adults-only evening, 6pm–8:30pm. Deck the Halls by candlelight with live musicians, bubbles and a mince pie on arrival.',
      image: imgCandlelight,
      location: 'Castle',
      link: '/christmas/castle-by-candlelight',
      linkText: 'Discover Castle by Candlelight',
      ticketTier: '£40pp',
      eventTags: ['christmas', 'evening', 'adult'],
      eventDetails: {
        eventDate: '2026-12-01',
        eventEndDate: '2026-12-30',
      }
    },
    {
      id: 'belvoir-festive-afternoon-tea-2026',
      title: 'Festive Afternoon Tea',
      subtitle: '14 November – 30 December 2026',
      date: '14 November – 30 December 2026',
      description: 'Seasonal savouries, festive patisserie and fine teas in the Aviary Tearoom. Book as an add-on to Castle or Gardens entry.',
      image: imgFestiveTea,
      location: 'Aviary Tearoom',
      link: '/christmas/festive-afternoon-tea',
      linkText: 'Discover Festive Afternoon Tea',
      ticketTier: 'Add-on',
      eventTags: ['christmas', 'dining', 'tea'],
      eventDetails: {
        eventDate: '2026-11-14',
        eventEndDate: '2026-12-30',
      }
    },
    {
      id: 'meet-santas-reindeer',
      title: "Meet Santa's Reindeer",
      subtitle: 'Saturday 19 December 2026 · 10am – 2pm',
      date: 'Saturday 19 December 2026 · 10am – 2pm',
      description: "Step into the magic of Christmas at Belvoir Retail Village and meet two of Santa's very own reindeer!",
      image: 'https://www.belvoircastle.com/wp/wp-content/uploads/2025/11/reindeer.webp',
      location: 'Retail Village',
      link: '/events/meet-santas-reindeer',
      linkText: 'View Details',
      price: 'No tickets required',
      eventTags: ['christmas', 'family'],
      eventDetails: {
        eventDate: '2026-12-19',
        eventEndDate: '2026-12-19',
        eventTime: '10am – 2pm',
      }
    }
  ];

  const vineyardEvents = [
    {
      id: 'belvoir-vineyard-tours-2026',
      title: 'Vineyard Tours',
      subtitle: 'Saturday 29 August 2026',
      date: 'Saturday 29 August 2026',
      description: 'Discover the art of wine making with expert guide Alasdair Lawson-Dick. Gun Bus through the estate, tour the vines with our Estates Team, and sample 4 estate wines with personal tasting boxes. Over 18s only.',
      image: vineyardImage,
      location: 'Retail Village Farm Shop',
      link: '/whats-on/vineyard-tour',
      linkText: 'Book Vineyard Tour',
      eventTags: ['tour', 'wine', 'adult'],
      eventDetails: {
        eventDate: '2026-08-29',
        eventEndDate: '2026-08-29',
        eventTime: '12:00 – 14:30 & 15:00 – 17:30',
      }
    }
  ];

  const wellnessEvents = [
    {
      id: 'belvoir-wellness-day-2026',
      title: 'Belvoir Wellness — A Day of Discovery',
      subtitle: 'Sunday 20 September 2026',
      date: 'Sunday 20 September 2026',
      description: 'Her Grace invites you to Belvoir Castle for Mind, Body, Belvoir — yoga, sound baths, Chapel Services, Mind Body Belvoir Studio, and Sensory Tree Trail Tours. Castle entry at regular admission; wellness activities free.',
      image: 'https://BelvoirCastle.b-cdn.net/Wellness/Wellness%203%20(1).webp',
      location: 'Castle, Retail Village and Gardens',
      link: '/whats-on/belvoir-wellness',
      linkText: 'Discover Belvoir Wellness',
      ticketTier: 'Book online',
      eventTags: ['wellness', 'castle', 'nature'],
      eventDetails: {
        eventDate: '2026-09-20',
        eventEndDate: '2026-09-20',
        eventTime: '10:00 – 17:00',
      }
    }
  ];

  // Combine all hardcoded events
  const hardcodedEvents = [...halloweenEvents, ...vineyardEvents, ...wellnessEvents, ...antiquesMarketEvents];

  const christmasHighlights = [
    {
      title: "Santa's Grotto",
      description: 'Meet Santa in his Castle grotto — a magical moment for families.',
      image: imgGrotto,
      link: '/christmas/santas-grotto-options',
      linkText: 'Explore Santa\'s Grotto',
    },
    {
      title: 'Search for Santa',
      description: 'An exclusive family trail through the Castle to find Santa. Weekends only.',
      image: imgSearch,
      link: '/christmas/search-for-santa',
      linkText: 'Discover Search for Santa',
    },
    {
      title: 'The Great Mouse Journey',
      description: 'The mice are out in five towns. Find one, scan the QR code, and win a free family ticket.',
      image: imgMouseJourney,
      imagePosition: 'center 78%',
      link: '/christmas/mouse-map',
      linkText: 'Follow the journey',
    },
  ];

  // Past and WordPress events stay stored here. What's On renders the seasonal lists above.
  const eventsContent = eventsLoading ? [] :
    eventsData && eventsData.events && eventsData.events.nodes ?
    combineAndSortEvents(hardcodedEvents, eventsData.events.nodes) : filterPastHardcodedEvents(hardcodedEvents);
  void eventsContent;
  void eventsError;

  const heroInfo = {
    introImage: bannerHome1,
    introVideoSrc: playgroundVideo,
    introVideoDelay: 1000,
    brightOverlay: true,
    welcomeText: settings.homeHero?.welcomeText || "Welcome to",
    mainTitle: settings.homeHero?.mainTitle || "Belvoir Castle",
    subtitle: settings.homeHero?.subtitle || "HISTORIC GEM IN THE HEART OF ENGLAND",
    buttons: [
      {
        text: "Plan Your Visit",
        onClick: () => navigate('/your-visit')
      },
      {
        text: "Book Tickets",
        onClick: () => navigate('/your-visit/day-tickets')
      }
    ],
    infoColumns: [
      {
        title: "Castle",
        items: [
          castleOpeningDisplay.days,
          castleOpeningDisplay.times
        ],
        note: castleOpeningDisplay.note
      },
      {
        title: "Gardens & Playground",
        items: [
          gardensOpeningDisplay.days,
          gardensOpeningDisplay.times
        ],
        note: gardensOpeningDisplay.note
      },
      {
        title: "Retail Village",
        items: [
          openingHoursData.retail?.days || "Mon - Sun",
          openingHoursData.retail?.times || "09:00 - 17:00"
        ],
        note: openingHoursData.retail?.note || ""
      }
    ]
  };


  return (
    <>
      <Helmet>
        <title>Belvoir Castle | Historic Castle & Gardens in Leicestershire</title>
        <meta name="description" content="Visit Belvoir Castle, a historic castle and gardens in Leicestershire. Explore the castle, gardens, and enjoy afternoon tea in our tearooms." />
        <link rel="canonical" href={getCanonicalUrl('')} />
        <meta property="og:title" content="Belvoir Castle | Historic Castle & Gardens in Leicestershire" />
        <meta property="og:description" content="Visit Belvoir Castle, a historic castle and gardens in Leicestershire. Explore the castle, gardens, and enjoy afternoon tea in our tearooms." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={getCanonicalUrl('')} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Belvoir Castle | Historic Castle & Gardens in Leicestershire" />
        <meta name="twitter:description" content="Visit Belvoir Castle, a historic castle and gardens in Leicestershire. Explore the castle, gardens, and enjoy afternoon tea in our tearooms." />
        <meta name="twitter:url" content={getCanonicalUrl('')} />
      </Helmet>
      <HomeContainer>
        <Hero {...heroInfo} />

        <ImageSlider
          slides={sliderContent}
          intro={
            <ExploreIntro>
              <ExploreEyebrow>Explore Belvoir</ExploreEyebrow>
              <ExploreDivider />
              <ExploreTitle>Where will your <em>visit</em> take you?</ExploreTitle>
              <ExploreSubtitle>
                From the castle and gardens to the retail village and farm shop &mdash; drag or swipe the cards below.
              </ExploreSubtitle>
            </ExploreIntro>
          }
        />
        {/* <ToursSlider /> */}

        {!isHalloweenAndEarlyBirdRetired() && (
        <HomeWitchPanel aria-label="Coming this October — Belvoir's Enchanted Halloween Trail">
          <HomeWitchBg aria-hidden="true" />
          <HomeWitchInner>
            <HomeWitchIcon aria-hidden="true">
              <FontAwesomeIcon icon={faHatWizard} />
            </HomeWitchIcon>
            <HomeWitchHeadline>The witch has cursed Belvoir.</HomeWitchHeadline>
            <HomeWitchBody>
              Come back in October as Curse Breakers — can your family solve the mystery and free
              Stuart&apos;s friends before the Enchanted Halloween Trail is over?
            </HomeWitchBody>
            <HomeWitchBtn type="button" onClick={() => navigate('/halloween-belvoir-castle')}>
              Discover Enchanted Halloween Trail
            </HomeWitchBtn>
          </HomeWitchInner>
        </HomeWitchPanel>
        )}

        <FreeClubsSection>
          <FreeClubsContainer>
            <FreeClubsBadge>Free to Join</FreeClubsBadge>
            <FreeClubsTitle>Free Clubs &amp; Classes</FreeClubsTitle>
            <FreeClubsDescription>
              Join our brand new Belvoir Orchard Tour &amp; Talk, Belvoir Book Club, and Woodland Walks &amp; Nature Talks. Completely free and open to everyone — discover, learn and connect at Belvoir Castle.
            </FreeClubsDescription>
            <FreeClubsGrid>
              <FreeClubCard>
                <FreeClubName>Woodland Walks &amp; Nature Talks</FreeClubName>
                <FreeClubBookBtn onClick={() => window.open('https://www.belvoircastle.com/booking-journey?locationId=978&pageId=027c88c6-911d-4135-9e63-9b301748aa88', '_blank')}>
                  Book now
                </FreeClubBookBtn>
              </FreeClubCard>
              <FreeClubCard>
                <FreeClubName>Belvoir Orchard Tour &amp; Talk</FreeClubName>
                <FreeClubBookBtn onClick={() => window.open('https://www.belvoircastle.com/booking-journey?locationId=978&pageId=f8d93684-3da6-408c-b49e-db93c422567b', '_blank')}>
                  Book now
                </FreeClubBookBtn>
              </FreeClubCard>
              <FreeClubCard>
                <FreeClubName>Belvoir Book Club</FreeClubName>
                <FreeClubBookBtn onClick={() => window.open('https://www.belvoircastle.com/booking-journey?locationId=978&pageId=ab4e21c4-31fc-48c6-a87a-7e394e35160e', '_blank')}>
                  Book now
                </FreeClubBookBtn>
              </FreeClubCard>
            </FreeClubsGrid>
            <FreeClubsPageLink onClick={() => navigate('/whats-on/free-clubs-and-classes')}>
              Find out more about our clubs
            </FreeClubsPageLink>
          </FreeClubsContainer>
        </FreeClubsSection>

        <ChristmasSection aria-label="Christmas at Belvoir Castle">
          <ChristmasInner>
            <ChristmasHeader>
              <ChristmasEyebrow>Christmas at Belvoir</ChristmasEyebrow>
              <ChristmasDivider />
              <ChristmasTitle>A <em>festive</em> season at the Castle</ChristmasTitle>
              <ChristmasLead>
                From Santa&apos;s Grotto and family trails to candlelit evenings and seasonal workshops —
                discover everything happening at Belvoir this Christmas.
              </ChristmasLead>
            </ChristmasHeader>

            <ChristmasGrid>
              {christmasHighlights.map((item) => (
                <ChristmasCard
                  key={item.link}
                  type="button"
                  onClick={() => navigate(item.link)}
                >
                  <ChristmasCardImage
                    src={item.image}
                    alt={item.title}
                    style={item.imagePosition ? { objectPosition: item.imagePosition } : undefined}
                  />
                  <ChristmasCardBody>
                    <ChristmasCardTitle>{item.title}</ChristmasCardTitle>
                    <ChristmasCardText>{item.description}</ChristmasCardText>
                    <ChristmasCardLink>{item.linkText}</ChristmasCardLink>
                  </ChristmasCardBody>
                </ChristmasCard>
              ))}
            </ChristmasGrid>

            <ChristmasCtaRow>
              <ChristmasPrimaryBtn type="button" onClick={() => navigate('/christmas')}>
                Explore Christmas
              </ChristmasPrimaryBtn>
              <ChristmasSecondaryBtn type="button" onClick={() => navigate('/christmas/tickets')}>
                Book Tickets
              </ChristmasSecondaryBtn>
            </ChristmasCtaRow>
          </ChristmasInner>
        </ChristmasSection>

        {!isHalloweenAndEarlyBirdRetired() && (
        <WhatsOn
          title="What's On at Belvoir Castle"
          events={halloweenEvents}
          wheelScroll
          showParklandSection={false}
        />
        )}

        <MouseJourneyBanner band />

        <WhatsOn
          title="Christmas at Belvoir"
          headerEyebrow="Christmas 2026"
          events={christmasWhatsOnEvents}
          wheelScroll
          showParklandSection={false}
        />
        
        <ColumnX2 
          title={settings.familySection?.title || "An Unforgettable Family Day Out"}
          description={settings.familySection?.description || "Discover the magic of Belvoir Castle with a day filled with adventure, history, and stunning countryside views. Explore grand interiors, wander through beautiful gardens, and enjoy family-friendly activities throughout the year. Whether you're exploring our woodland trails, indulging in delicious treats at the Belvoir Retail Village, or experiencing one of our exciting seasonal events, there's something for everyone to enjoy."}
          buttonText="Plan Your Visit"
          buttonAction={() => navigate('/your-visit')}
          secondaryButtonText={<BringYourDogLabel />}
          secondaryButtonAction={() => navigate('/about/dog-friendly')}
        />
        <NewsletterSignUp />
      
        <ImageSlant 
          image={discoverCastleImage}
          title="Discover Our Castle"
          description="Step into centuries of history at Belvoir Castle. Experience the grandeur of our State Rooms and immerse yourself in the stories of those who lived here."
          buttonText="Learn More"
          buttonAction={() => navigate('/about/castle-and-state-rooms')}
          imagePosition="left"
        />
        <ImageSlant 
          image={beautifulGardensImage}
          title="Beautiful Gardens"
          description="Explore our meticulously maintained gardens, featuring stunning landscapes and seasonal blooms throughout the year."
          buttonText="View Gardens"
          buttonAction={() => navigate('/about/gardens')}
          imagePosition="right"
        />
        <ImageSlant 
          image={featuredToursImage}
          title="Featured Tours"
          description="Explore the rich history of Belvoir Castle with our exclusive guided tours. Discover our Castle's secrets, parkland, and gardens on these 1 ½ hour immersive experiences."
          buttonText="View Tours"
          buttonAction={() => navigate('/whats-on/featured-tours')}
          imagePosition="left"
        />
        <ImageSlant 
          image={vineyardToursImage}
          title="Vineyard Tours"
          description="Discover the art of wine making with expert guide Alasdair Lawson-Dick. Explore the vines, sample 4 estate wines, and travel the historic estate by Gun Bus."
          buttonText="Find Out More"
          buttonAction={() => navigate('/whats-on/vineyard-tour')}
          imagePosition="right"
        />
        <Footer />
      </HomeContainer>

    </>
  );
};

export default Home;
